<template>
    <div class="pop-over">
        <div>
            <div class="info-container">
                <div class="introduction-text introduction-header">{{ $t('introduction.principles') }}</div>
                <div class="introduction-text">
                    <div class="list-text">{{ $t('introduction.principle_1') }}</div>
                    <div class="list-text">{{ $t('introduction.principle_2') }}</div>
                    <div class="list-text">{{ $t('introduction.principle_3') }}</div>
                    <div class="list-text">{{ $t('introduction.principle_4') }}</div>
                </div>

                <div class="introduction-text introduction-header">{{ $t('introduction.data_processing') }}</div>
                <div class="introduction-text">
                    <div class="list-text">{{ $t('introduction.data_processing_1') }}</div>
                    <div class="list-text">{{ $t('introduction.data_processing_2') }}</div>
                    <div class="list-text">{{ $t('introduction.data_processing_3') }}</div>
                    <div class="list-text">{{ $t('introduction.data_processing_4') }}</div>
                    <div class="list-text">{{ $t('introduction.data_processing_5') }}</div>
                </div>
            </div>
            <div class="footer">
                <div class="navigation-buttons" />

                <div class="navigation-buttons" @click="close">
                    <button class="btn btn-outline-dark next" type="submit">
                        OK
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>
  
<script>
export default {
    name: 'DataPrinciples',
    watch: {},
    methods: {
        close() {
            this.$emit("close");
        },
    },
    mounted() {

    }
};
</script>
  
<style scoped>
.pop-over {
    padding: 2rem;
    background-color: #f0f0f2;
    position: fixed;
    margin-left: 30%;
    z-index: 20;
    height: 600px;
    width: 700px;
    margin-top: 4rem;
    border-radius: 15px;

}


.footer {
    display: grid;
    grid-gap: 10px;
    padding: 60px 10px 10px 0;
    grid-template-columns: 90% 10%;
}


.introduction-text {
    text-align: justify;
    padding-left: 5rem;
    padding-right: 5rem;
    padding-bottom: 1rem;
    font-size: 1rem;
}

.introduction-header {
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
    font-weight: bolder;
}

.info-container {
    overflow-y: scroll;
    height: 400px;
    text-align: left;
}
</style>
  